import React, { useMemo, useState } from "react";
import { ExternalLink } from "lucide-react";
import useAsync from "../../utils/useAsync.js";
import { getFilings } from "../../utils/stockApi.js";
import { FILING_FORMS } from "../../utils/stockData.js";
import { fmtLongDate } from "../../utils/format.js";
import { Loading, ErrorBox, Chips } from "./common.jsx";

export default function FilingsTab({ ticker }) {
  const { data, loading, error } = useAsync(() => getFilings(ticker), [ticker]);
  const [form, setForm] = useState("All");
  const [limit, setLimit] = useState(15);

  const rows = useMemo(
    () => (data || []).filter((f) => form === "All" || f.form === form),
    [data, form]
  );

  if (loading) return <Loading />;
  if (error) return <ErrorBox error={error} />;

  return (
    <div>
      <div className="co-toolbar">
        <Chips items={FILING_FORMS} value={form} onChange={(f) => { setForm(f); setLimit(15); }} />
      </div>
      <div className="card co-card co-table-wrap">
        <table className="co-table co-table-left">
          <thead><tr><th>Date</th><th>Form</th><th>Description</th><th /></tr></thead>
          <tbody>
            {rows.slice(0, limit).map((f, i) => (
              <tr key={i}>
                <td>{fmtLongDate(f.date)}</td>
                <td><span className="badge-purple">{f.form}</span></td>
                <td>{f.description}</td>
                <td>
                  <a href={f.url} target="_blank" rel="noreferrer" title="Find on SEC EDGAR">
                    EDGAR <ExternalLink size={12} />
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {rows.length > limit && (
          <div className="co-more">
            <button className="btn tool-btn" onClick={() => setLimit(limit + 15)}>Show more</button>
          </div>
        )}
      </div>
      <p className="co-hint">Dates are sample values; links open the company's real filing list on SEC EDGAR.</p>
    </div>
  );
}
